import React from "react";
import { Redirect } from "react-router-dom";
import Home from "../pages/Auth/Home";
import Login from "../pages/Auth/Login/Login";
import ResetPassword from "../pages/Auth/Login/ResetPassword";
import Unauthorized from "../pages/Auth/Unauthorized";
import AddEval from "../pages/QualityMonotoring/AddEval";
import AddCalibEval from "../pages/Calibrages/AddEvalCalibrage";
import QualityMonotoring from "../pages/QualityMonotoring/QualityMonotoring";
import Reporting from "../pages/Reporting/Reporting";
import Managment from "../pages/Managment/Managment";
import QualityManagment from "../pages/QualityManagment/QualityManagment";
import AddGrille from "../pages/QualityMonotoring/AddGrille";
import Caliber from "../pages/QualityMonotoring/CalibrageEnCours";
import DetailsCalibrage from "../pages/QualityMonotoring/CalibrageEnCours/detailCalibrageAdmin";
import EditGrille from "../pages/QualityMonotoring/EditGrille";
import DuplicateGrid from "../pages/QualityMonotoring/duplicateGrille";
import Page404 from "../pages/Auth/Login/404";
import ListEvalsCompared from "../pages/QualityMonotoring/ListEvalsCompared/ListEvalsCompared";
const authProtectedRoutes = [
  {
    path: "/home",
    role: ["SUPER-ADMIN", "ADMIN", "MANAGER", "AGENT"],
    name: "Home",
    component: Home,
  },
  {
    path: "/add-eval",
    role: ["ADMIN", "MANAGER", "AGENT"],
    name: "Add Eval",
    component: AddEval,
  },
  {
    path: "/add-eval-calib",
    role: ["ADMIN", "MANAGER", "AGENT"],
    name: "Add Eval Calib",
    component: AddCalibEval,
  },
  {
    path: "/add-grille",
    role: ["ADMIN", "MANAGER", "AGENT"],
    name: "Add Grille",
    component: AddGrille,
  },
  {
    path: "/calibrage-en-cours",
    role: ["ADMIN", "MANAGER", "AGENT"],
    name: "Caliber",
    component: Caliber,
  },
  {
    path: "/calibrage-en-cours",
    role: ["ADMIN", "MANAGER"],
    name: "Caliber",
    component: Caliber,
  },
  {
    path: "/details-calibrage",
    role: ["ADMIN", "MANAGER"],
    name: "Caliber",
    component: DetailsCalibrage,
  },
  {
    path: "/dup-grille",
    role: ["ADMIN", "MANAGER", "AGENT"],
    name: "Dup Grille",
    component: DuplicateGrid,
  },
  {
    path: "/update-grille",
    role: ["ADMIN", "MANAGER", "AGENT"],
    name: "Edit Grille",
    component: EditGrille,
  },
  {
    path: "/quality-monitoring",
    role: ["SUPER-ADMIN", "ADMIN", "MANAGER", "AGENT"],
    name: "Quality Monitoring",
    component: QualityMonotoring,
  },
  {
    path: "/evals-compared",
    role: ["SUPER-ADMIN", "ADMIN", "MANAGER", "AGENT"],
    name: "Evals Compared",
    component: ListEvalsCompared,
  },
  {
    path: "/reporting",
    role: ["SUPER-ADMIN", "ADMIN", "MANAGER", "AGENT"],
    name: "Reporting",
    component: Reporting,
  },
  {
    path: "/admin",
    role: ["SUPER-ADMIN", "ADMIN", "MANAGER", "AGENT"],
    name: "Managment",
    component: Managment,
  },
  {
    path: "/quality-managment",
    role: ["MANAGER", "ADMIN", "AGENT"],
    name: "Quality Managment",
    component: QualityManagment,
  },
  {
    path: "/admin/clients",
    role: ["SUPER-ADMIN"],
    name: "clients list",
    // component: Clients,
  },
  { path: "/unauthorized", component: Unauthorized },
  { path: "/", exact: true, component: () => <Redirect to="/home" /> },
];

const publicRoutes = [
  { path: "/login", name: "Login", component: Login },
  { path: "/404", name: "404", component: Page404 },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
];

export { authProtectedRoutes, publicRoutes };
